import { render, staticRenderFns } from "./AiBusinessPromoter.vue?vue&type=template&id=07bcae94&scoped=true&"
import script from "./AiBusinessPromoter.vue?vue&type=script&lang=js&"
export * from "./AiBusinessPromoter.vue?vue&type=script&lang=js&"
import style0 from "./AiBusinessPromoter.vue?vue&type=style&index=0&id=07bcae94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bcae94",
  null
  
)

export default component.exports